import { render } from "./login-modify-pass.vue?vue&type=template&id=4b4c4440&scoped=true"
import script from "./login-modify-pass.vue?vue&type=script&lang=js"
export * from "./login-modify-pass.vue?vue&type=script&lang=js"

import "./login-modify-pass.vue?vue&type=style&index=0&id=4b4c4440&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lot\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4c4440"]])

export default __exports__